module.exports = __webpack_public_path__ + "static/img/7.c56d201.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rent_shop/7.png
// module id = dXR5
// module chunks = 1